// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Kgxlg","inputWrap":"styles_inputWrap__16iT4","input":"styles_input__2Fc4-"};